module.exports = "pegasus/assets/blocks/column-17-theme6.png";